<template>
  <div class="card border-top-start-radius-0 border-top-end-radius-0 avaliacao-card">
    <div class="card-body">
      <div class="row mb-4 text-center">
        <div class="col-12 col-md-3">
          <h4 class="postural-photo-title">{{ $t('rightLateral') }}</h4>
          <div
            class="postural-photo-area"
            @click="$refs.fileInputDireita.click()"
          >
            <input
              type="file"
              ref="fileInputDireita"
              @change="uploadImage($event, 'direita')"
              class="inputfile"
            />
            <img
              v-if="state.images.direita.url"
              :src="state.images.direita.url"
              :alt="$t('rightLateral') + ' photo of the student'"
            />
            <span class="small" v-else>{{ $t('clickToSelectPhoto') }}</span>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <h4 class="postural-photo-title">{{ $t('leftLateral') }}</h4>
          <div
            class="postural-photo-area"
            @click="$refs.fileInputEsquerda.click()"
          >
            <input
              type="file"
              ref="fileInputEsquerda"
              @change="uploadImage($event, 'esquerda')"
              class="inputfile"
            />
            <img
              v-if="state.images.esquerda.url"
              :src="state.images.esquerda.url"
              :alt="$t('leftLateral') + ' photo of the student'"
            />
            <span class="small" v-else>{{ $t('clickToSelectPhoto') }}</span>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <h4 class="postural-photo-title">{{ $t('posterior') }}</h4>
          <div
            class="postural-photo-area"
            @click="$refs.fileInputPosterior.click()"
          >
            <input
              type="file"
              ref="fileInputPosterior"
              @change="uploadImage($event, 'posterior')"
              class="inputfile"
            />
            <img
              v-if="state.images.posterior.url"
              :src="state.images.posterior.url"
              :alt="$t('posterior') + ' photo of the student'"
            />
            <span class="small" v-else>{{ $t('clickToSelectPhoto') }}</span>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <h4 class="postural-photo-title">{{ $t('anterior') }}</h4>
          <div
            class="postural-photo-area"
            @click="$refs.fileInputAnterior.click()"
          >
            <input
              type="file"
              ref="fileInputAnterior"
              @change="uploadImage($event, 'anterior')"
              class="inputfile"
            />
            <img
              v-if="state.images.anterior.url"
              :src="state.images.anterior.url"
              :alt="$t('anterior') + ' photo of the student'"
            />
            <span class="small" v-else>{{ $t('clickToSelectPhoto') }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- Lateral View-->
        <div class="col-12 col-md-4">
          <div class="row">
            <div class="col-12 postural-section-header"><i class="fas fa-eye me-2"></i>{{ $t('lateralView') }}</div>
            <div class="col-12">
              <div
                class="postural-option-item pointer"
                v-for="(option, chave) in state.options['lateral']"
                :key="chave"
                :class="{ 'postural-option-checked': state.checkboxValues[chave] }"
              >
                <input
                  @change="selecionaItem($event, chave)"
                  class="mt-1 form-check-input postural-check"
                  type="checkbox"
                  value="1"
                  v-model="state.checkboxValues[chave]"
                />
                <span class="ms-1">
                  {{ option }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- Posterior View -->
        <div class="col-12 col-md-4">
          <div class="row">
            <div class="col-12 postural-section-header"><i class="fas fa-eye me-2"></i>{{ $t('posteriorView') }}</div>
            <div class="col-12">
              <div
                class="postural-option-item pointer"
                v-for="(option, chave) in state.options['posterior']"
                :key="chave"
                :class="{ 'postural-option-checked': state.checkboxValues[chave] }"
              >
                <input
                  @change="selecionaItem($event, chave)"
                  class="mt-1 form-check-input postural-check"
                  type="checkbox"
                  value="1"
                  v-model="state.checkboxValues[chave]"
                />
                <span class="ms-1">
                  {{ option }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- Anterior View -->
        <div class="col-12 col-md-4">
          <div class="row">
            <div class="col-12 postural-section-header"><i class="fas fa-eye me-2"></i>{{ $t('anteriorView') }}</div>
            <div class="col-12">
              <div
                class="postural-option-item pointer"
                v-for="(option, chave) in state.options['anterior']"
                :key="chave"
                :class="{ 'postural-option-checked': state.checkboxValues[chave] }"
              >
                <input
                  @change="selecionaItem($event, chave)"
                  class="mt-1 form-check-input postural-check"
                  type="checkbox"
                  value="1"
                  v-model="state.checkboxValues[chave]"
                />
                <span class="ms-1">
                  {{ option }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-end mt-3">
          <router-link to="/avaliacao-fisica">
            <button type="button" class="btn bg-gradient-secondary">
              {{ $t('back') }}
            </button>
          </router-link>
          <button type="button" class="ms-3 btn bg-gradient-primary" @click.prevent="salvar">
            {{ $t('save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, ref, inject, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { Money3Component } from 'v-money3'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import avaliacaoPosturalRepository from '@/services/api/avaliacaoPosturalRepository'

export default {
  components: {
    money3: Money3Component,
  },
  props: {
    avaliacaoIdProp: {
      type: Number,
      default: 0,
    },
  },
  setup(props, context) {
    const { t } = useI18n()
    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')
    const store = useStore()

    onMounted(() => {
      state.avaliacaoId = props.avaliacaoIdProp
      buscarDados()
    })

    const state = reactive({
      id: 0,
      avaliacaoId: 0,
      checkboxValues: {},
      images: {
        esquerda: {
          url: null,
          file: null,
        },
        direita: {
          url: null,
          file: null,
        },
        anterior: {
          url: null,
          file: null,
        },
        posterior: {
          url: null,
          file: null,
        },
      },
      options: {
        lateral: {
          hip_anthropoversion: t('hipAnthropoversion'),
          hip_retroversion: t('hipRetroversion'),
          shoulder_retroversion: t('shoulderRetroversion'),
          cervical_straightening: t('cervicalStraightening'),
          lumbar_straightening: t('lumbarStraightening'),
          abdominal_protrusion: t('abdominalProtrusion'),
          cervical_hyperlordosis: t('cervicalHyperlordosis'),
          lumbar_hyperlordosis: t('lumbarHyperlordosis'),
          thoracic_hyperlordosis: t('thoracicHyperlordosis'),
          flat_foot: t('flatFoot'),
          cavus_foot: t('cavusFoot'),
          heel_foot: t('heelFoot'),
          equine_foot: t('equineFoot'),
          knee_flexion: t('kneeFlexion'),
          knee_bent: t('kneeBent'),
        },
        posterior: {
          cervical_scoliosis: t('cervicalScoliosis'),
          thoracic_scoliosis: t('thoracicScoliosis'),
          lumbar_scoliosis: t('lumbarScoliosis'),
          scapular_protrusion: t('scapularProtrusion'),
          scapular_retraction: t('scapularRetraction'),
          scapular_depression: t('scapularDepression'),
          valgus_foot: t('valgusFoot'),
          varus_foot: t('varusFoot'),
          trapezius_shortening: t('trapeziusShortening'),
        },
        anterior: {
          valgus_knee: t('valgusKnee'),
          varus_knee: t('varusKnee'),
          adduct_foot: t('adductFoot'),
          abduct_foot: t('abductFoot'),
          shoulder_no_elevation: t('shoulderNoElevation'),
          shoulder_elevation_right: t('shoulderElevationRight'),
          shoulder_elevation_left: t('shoulderElevationLeft'),
          hip_no_elevation: t('hipNoElevation'),
          right_pelvis_elevation: t('rightPelvisElevation'),
          left_pelvis_elevation: t('leftPelvisElevation'),
        },
      },
    })

    function uploadImage(e, lado) {
      const file = e.target.files[0]
      let image = URL.createObjectURL(file)
      if (lado == 'direita') {
        state.images.direita.file = file
        state.images.direita.url = image
      }
      if (lado == 'esquerda') {
        state.images.esquerda.file = file
        state.images.esquerda.url = image
      }
      if (lado == 'posterior') {
        state.images.posterior.file = file
        state.images.posterior.url = image
      }
      if (lado == 'anterior') {
        state.images.anterior.file = file
        state.images.anterior.url = image
      }
    }

    function selecionaItem(event, chave) {
      /*Object.keys(state.checkboxValues).forEach((chave) => {
        let valor = state.checkboxValues[chave];
        console.log(`Chave: ${chave}, Valor: ${valor}`);
      });*/
    }

    async function buscarDados() {
      store.commit('SET_SPLASH_SCREEN', true)
      try {
        if (state.avaliacaoId !== 0) {
          let response = await avaliacaoPosturalRepository.PosturalGetByAssessmentId(
            state.avaliacaoId,
          )
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            if (response.data.data != null) {
              state.checkboxValues = response.data.data
              state.id = response.data.data.id

              generatePreview(
                response.data.data.photo_right,
                response.data.data.photo_left,
                response.data.data.photo_posterior,
                response.data.data.photo_ant,
              )
            }
          }
        }
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        console.error(error)
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    function generatePreview(direito, esquerdo, posterior, anterior) {
      // Verifica se a URL da imagem não está vazia

      if (direito != null && direito.trim() !== '') {
        direito = `https://diariodetreino.agilesaas.sbs/storage/${direito}`
        // Verifica se a URL é válida
        if (isValidImageUrl(direito)) {
          state.images.direita.url = direito
        }
      }
      if (esquerdo != null && esquerdo.trim() !== '') {
        esquerdo = `https://diariodetreino.agilesaas.sbs/storage/${esquerdo}`
        // Verifica se a URL é válida
        if (isValidImageUrl(esquerdo)) {
          state.images.esquerda.url = esquerdo
        }
      }
      if (posterior != null && posterior.trim() !== '') {
        posterior = `http://diariodetreino.agilesaas.sbs/storage/${posterior}`
        // Verifica se a URL é válida
        if (isValidImageUrl(posterior)) {
          state.images.posterior.url = posterior
        }
      }
      if (anterior != null && anterior.trim() !== '') {
        anterior = `http://diariodetreino.agilesaas.sbs/storage/${anterior}`
        // Verifica se a URL é válida
        if (isValidImageUrl(anterior)) {
          state.images.anterior.url = anterior
        }
      }
    }

    function isValidImageUrl(url) {
      // Regex para verificar a URL da imagem
      // Pode não ser 100% precisa, mas é um bom ponto de partida
      const pattern = /^((http|https):\/\/)/
      return pattern.test(url)
    }

    function salvar() {
      /*let images = {
        photo_right: ,
        photo_left: state.images.direita.file,
        photo_posterior: state.images.direita.file,
        photo_ant: state.images.direita.file,
      }*/
      const formDataitems = new FormData()
      if (state.images.direita.file) {
        formDataitems.append('photo_right', state.images.direita.file)
      }
      if (state.images.esquerda.file) {
        formDataitems.append('photo_left', state.images.esquerda.file)
      }
      if (state.images.posterior.file) {
        formDataitems.append('photo_posterior', state.images.posterior.file)
      }
      if (state.images.anterior.file) {
        formDataitems.append('photo_ant', state.images.anterior.file)
      }

      formDataitems.append('items', JSON.stringify(state.checkboxValues))

      try {
        if (state.avaliacaoId == 0 && route.params.id && parseInt(route.params.id) > 0) {
          state.avaliacaoId = parseInt(route.params.id)
        }
        store.commit('SET_SPLASH_SCREEN', true)

        if (state.avaliacaoId == 0) {
          context.emit('salvar', formDataitems, 'postural')
        } else {
          formDataitems.append('student_physical_assessment_id', state.avaliacaoId)

          avaliacaoPosturalRepository.PosturalPost(formDataitems).then((response) => {
            store.commit('SET_SPLASH_SCREEN', false)

            if (response.data.success) {
              swal({
                title: 'Avaliação postural',
                text: 'Avaliação postural cadastrado com sucesso!',
                icon: 'success',
                customClass: {
                  confirmButton: 'btn bg-gradient-success',
                },
                buttonsStyling: false,
              })
            }
          })

          /*if(state.id == undefined || state.id == 0) {
            avaliacaoPosturalRepository.PosturalPost(formDataitems).then(response => {
              store.commit('SET_SPLASH_SCREEN', false)

              if (response.data.success) {
                swal({
                  title: "Avaliação postural",
                  text: "Avaliação postural cadastrado com sucesso!",
                  icon: "success",
                  customClass: {
                    confirmButton: "btn bg-gradient-success",
                  },
                  buttonsStyling: false,
                })
              }
            })
          } else {
            avaliacaoPosturalRepository.PosturalPut(state.id, formDataitems).then(response => {
              store.commit('SET_SPLASH_SCREEN', false)

              if (response.data.success) {
                swal({
                  title: "Avaliação postural",
                  text: "Avaliação postural cadastrado com sucesso!",
                  icon: "success",
                  customClass: {
                    confirmButton: "btn bg-gradient-success",
                  },
                  buttonsStyling: false,
                })
              }
            })
          }*/
        }
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        console.error(error)
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    return {
      state,
      salvar,
      selecionaItem,
      uploadImage,
    }
  },
}
</script>

<style scoped>
.avaliacao-card {
  border: 1px solid #d0d5e0;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.postural-photo-title {
  color: #2D3A7C;
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 8px;
}
.postural-photo-area {
  height: 300px;
  border: 2px dashed #b8c0d8;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f6f8fb;
  cursor: pointer;
  transition: all 0.25s;
  overflow: hidden;
}
.postural-photo-area:hover {
  border-color: #F7941D;
  background: #edf0f6;
  box-shadow: 0 0 0 3px rgba(247, 148, 29, 0.15);
}
.postural-photo-area img {
  max-height: 300px;
  object-fit: contain;
  width: 100%;
}
.postural-photo-area .small {
  color: #8392ab;
  font-size: 0.85rem;
}
.postural-section-header {
  background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%);
  color: #fff;
  font-weight: 700;
  font-size: 0.92rem;
  padding: 10px 16px;
  border-radius: 8px;
  margin-bottom: 12px;
  margin-top: 8px;
}
.postural-option-item {
  display: flex;
  align-items: center;
  padding: 8px 14px;
  margin-bottom: 4px;
  border-radius: 8px;
  border: 1.5px solid #e8eaf0;
  background: #fff;
  transition: all 0.2s;
  cursor: pointer;
}
.postural-option-item:hover {
  border-color: #2D3A7C;
  background: #edf0f6;
}
.postural-option-checked {
  border-color: #2D3A7C !important;
  background: linear-gradient(135deg, #edf0f6 0%, #e4e8f0 100%) !important;
  box-shadow: 0 0 0 2px rgba(45, 58, 124, 0.15);
}
.postural-check {
  width: 18px;
  height: 18px;
  border: 2px solid #2D3A7C !important;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.postural-check:checked {
  background-color: #F7941D !important;
  border-color: #F7941D !important;
}
</style>
